import { Filter, Close } from '@metservicedev/met-ui/icons-v1';
import { useSettingsContext } from '@mono/platmap-settings-context';
import { Layer } from '@mono/types/src/platmap';
import { Tooltip, Popover, Checkbox } from 'antd';
import { isLightningLayer, isWXTilesV3Layer } from 'layerTypeUtils';
import React, { useState } from 'react';
import { getLayerFromVariable, WxVariables } from '@mono/layer-variable-utils';

const toggleableLayer = (layer: Layer) => {
    return isWXTilesV3Layer(layer) || isLightningLayer(layer);
};
const layerOption = (layer: Layer) => {
    if (isWXTilesV3Layer(layer)) {
        if (!layer.state.datasetId) return undefined;
        return { label: getLayerFromVariable(layer.state.variable as WxVariables | WxVariables[]), value: layer.id };
    }
    if (isLightningLayer(layer)) {
        return { label: 'Lightning', value: layer.id };
    }
    return undefined;
};

export const LayersControl = ({
    disabledLayers,
    setDisabledLayers,
}: {
    disabledLayers: string[];
    setDisabledLayers: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
    const [showLayer, setShowLayer] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const { settings } = useSettingsContext();

    const layers = settings?.layers?.filter(toggleableLayer);

    const options = layers.map((layer) => layerOption(layer)).filter((o) => o !== undefined);

    return (
        <div
            style={{
                height: 32,
                width: 32,
                background: 'rgba(255,255,255,0.5)',
                borderRadius: 4,
                padding: 8,
                cursor: 'pointer',
            }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            <Tooltip title='Layers' placement='left' zIndex={1} open={showTooltip && !showLayer}>
                <Popover
                    content={
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            {options.map((opt) => {
                                return (
                                    <Checkbox
                                        style={{ marginLeft: 0 }}
                                        key={opt.value}
                                        checked={!disabledLayers.includes(opt.value)}
                                        onChange={(e) => {
                                            setDisabledLayers(
                                                e.target.checked ? disabledLayers.filter((l) => l !== opt.value) : [...disabledLayers, opt.value]
                                            );
                                        }}
                                    >
                                        {opt.label}
                                    </Checkbox>
                                );
                            })}
                        </div>
                    }
                    placement='left'
                    title='Layers'
                    trigger='click'
                    open={showLayer}
                    onOpenChange={(bool) => {
                        setShowLayer(bool);
                        setShowTooltip(!bool);
                    }}
                    zIndex={2}
                >
                    <span>{showLayer ? <Close /> : <Filter />}</span>
                </Popover>
            </Tooltip>
        </div>
    );
};
